export default "__VITE_ASSET__B55EJptA__"